module.exports = __webpack_public_path__ + "4b3701ac38e2f6dc6db38fbd37b2351b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/hannukaih.png
// module id = 2047
// module chunks = 0